import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useEffect, forwardRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import * as React from "react";
import { CapitalAmount } from "../../app/slices/capitalAmountSlice";

export const SelectCapitalAmountType = forwardRef((props, ref) => {
  const { value, onChange, ...rest } = props;
  const dispatch = useDispatch();

  const _Types = useSelector(
    (state) => state.capitalAmount.capitalAmountTypes.data
  );
  const loading = useSelector(
    (state) => state.capitalAmount.capitalAmountTypes.loading
  );

  useEffect(() => {
    dispatch(CapitalAmount.getTypes());
  }, [dispatch]);

  return (
    <Autocomplete
      ref={ref}
      {...rest}
      options={_Types || []}
      value={
        _Types?.find((option) => option.id === (value?.id ?? value)) ?? null
      }
      onChange={onChange}
      getOptionLabel={(option) => option.name ?? ""}
      isOptionEqualToValue={(option, val) => option?.id === val?.id}
      renderInput={(params) => (
        <TextField
          required={props.required}
          error={props.error}
          helperText={props.helperText}
          {...params}
          label="نوع رأس المال"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
});
